<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Προφίλ Χρήστη</h4>

              <b-tabs
                justified
                nav-class="nav-tabs-custom"
                content-class="p-3 text-muted"
              >
                <b-tab active>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="far fa-user"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Πληροφορίες</span>
                  </template>
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title mb-4">Πληροφορίες Χρήστη</h4>

                      <div class="table-responsive ">
                        <table class="table table-nowrap mb-0">
                          <tbody>
                            <tr>
                              <th scope="row">Ονοματεπώνυμο :</th>

                              <td>
                                {{ userDetails.user.first_name }}
                                {{ userDetails.user.last_name }}
                              </td>
                            </tr>

                            <tr>
                              <th scope="row">Όνομα Πατρός :</th>
                              <td>
                                {{ currentUserDetails.fathers_name }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Τηλ :</th>
                              <td>{{ currentUserDetails.phone }}</td>
                            </tr>
                            <tr>
                              <th scope="row">E-mail :</th>
                              <td>
                                {{ userDetails.user.email }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Τμήμα :</th>
                              <td>
                                {{ currentUserDepartments }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Ρόλος :</th>
                              <td>
                                {{ translateRole(currentUserDetails.role) }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Δευτερεύον ρόλος :</th>
                              <td v-if="currentUserDetails.secondary_role">
                                {{ currentUserDetails.secondary_role }}
                              </td>
                              <td v-else>
                                -
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Αριθμός κάρτας :</th>
                              <td>
                                {{ userCardNumber }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                      >Ωράριο Εργασίας</span
                    >
                  </template>
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title mb-4">Πρόγραμμα Εργασίας</h4>

                      <div class="table-responsive ">
                        <table class="table table-nowrap mb-0">
                          <tbody>
                            <tr
                              v-for="(scheduleData, index) in userSchedule"
                              :key="index"
                            >
                              <th scope="row">
                                {{ translateWeekdays(scheduleData.weekday) }}
                              </th>
                              <td>
                                {{
                                  scheduleData.start_time
                                    .split(":")
                                    .slice(0, -1)
                                    .join(":")
                                }}
                                -
                                {{
                                  scheduleData.end_time
                                    .split(":")
                                    .slice(0, -1)
                                    .join(":")
                                }}
                              </td>

                              <td>
                                {{ weekdays.join(", ") }}
                              </td>
                              <td>
                                Από:
                                {{
                                  scheduleData.start_date
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                }}
                              </td>
                              <td>
                                Εώς:
                                {{
                                  scheduleData.end_date
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-procedschedules"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Άδεια</span>
                  </template>
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title mb-4">Άδειες</h4>

                      <div class="table-responsive ">
                        <table class="table table-nowrap mb-0">
                          <tbody>
                            <tr>
                              <th scope="row">
                                A/A
                              </th>
                              <th scope="row">
                                Από
                              </th>
                              <th scope="row">
                                Έως
                              </th>
                              <th socpe="row">
                                Παρατηρήσεις
                              </th>
                            </tr>

                            <tr
                              v-for="(item, index) in userHolidays"
                              :key="index"
                            >
                              <td>
                                {{ index + 1 }}
                              </td>
                              <td>
                                {{ item.holidays_start_date }}
                              </td>
                              <td>
                                {{ item.holidays_end_date }}
                              </td>

                              <td v-if="item.comments">
                                {{ item.comments }}
                              </td>
                              <td v-else>
                                -
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="perPage"
                        :per-page="userHolidays.length"
                        aria-controls="my-table"
                        align="center"
                        @input="pageClick(currentPage)"
                      ></b-pagination>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                      >Αλλαγή Κωδικού πρόσβασης</span
                    >
                  </template>
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title mb-4">
                        Αλλάξτε τον κωδικό πρόσβασης
                      </h4>
                      <b-alert
                        v-if="alertMsg"
                        show
                        dismissible
                        :variant="alertVariant"
                        >{{ alertMsg }}</b-alert
                      >

                      <div class="table-responsive ">
                        <b-form-group
                          class="mb-3"
                          id="example-password"
                          label-cols-sm="2"
                          label-cols-lg="2"
                          label="Παλιός κώδικός πρόσβασης"
                          label-for="pwd"
                        >
                          <b-form-input
                            id="pwd"
                            type="password"
                            v-model="oldPassword"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group
                          class="mb-3"
                          id="example-password"
                          label-cols-sm="2"
                          label-cols-lg="2"
                          label="Καινούριος κωδικός"
                          label-for="pwd"
                        >
                          <b-form-input
                            id="pwd"
                            type="password"
                            v-model="newPassword"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group
                          class="mb-3"
                          id="example-password"
                          label-cols-sm="2"
                          label-cols-lg="2"
                          label="Καινούριος κωδικός πρόσβασης (ξανά)"
                          label-for="pwd"
                        >
                          <b-form-input
                            id="pwd"
                            type="password"
                            v-model="newPasswordAgain"
                          ></b-form-input>
                        </b-form-group>
                        <button
                          class="btn btn-primary"
                          @click.prevent="changePassword"
                        >
                          Ολοκλήρωση
                        </button>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>

    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import session from "../../../api/session";

import { mapGetters, mapState } from "vuex";
import { translateRole, translateWeekdays } from "../../../translations";

/**
 * Contacts-Profile component
 */
export default {
  page: {
    title: "ΠΡΟΦΙΛ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "προφιλ",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Προφίλ",
          active: true,
        },
      ],
      WEEKDAYS: [
        { id: 0, weekday: "Δευτέρα" },
        { id: 1, weekday: "Τρίτη" },
        { id: 2, weekday: "Τετάρτη" },
        { id: 3, weekday: "Πέμπτη" },
        { id: 4, weekday: "Παρασκευή" },
        { id: 5, weekday: "Σάββατο" },
        { id: 6, weekday: "Κυριακή" },
      ],
      userHolidays: "",
      holidaysHasNextPage: "",
      holidaysHasPreviousPage: "",
      currentPage: 1,
      perPage: "",
      totalPages: "",
      oldPassword: "",
      newPassword: "",
      newPasswordAgain: "",
      alertMsg: "",
      alertVariant: "",
    };
  },
  mounted() {
    // this.fetchUserHolidays();
  },
  computed: {
    ...mapGetters("auth", ["userDetails", "userRole"]),
    ...mapState("auth", ["currentUserDetails"]),

    currentUserDepartments() {
      return this.currentUserDetails.department
        .map((e) => {
          return e.department_parent_name;
        })
        .join(", ");
    },
    userCardNumber() {
      return this.currentUserDetails.person_device_identity
        ? this.currentUserDetails.person_device_identity
            .map((e) => e.card_number)
            .join("")
        : "";
    },
    userSchedule() {
      return this.currentUserDetails.schedule
        ? this.currentUserDetails.schedule
        : "";
    },
    weekdays() {
      return this.currentUserDetails.schedule[0].weekdays.map((e) => {
        return this.WEEKDAYS.find((item) => item.id === e.weekday).weekday;
      });
    },
  },
  methods: {
    translateRole,
    translateWeekdays,
    async fetchUserHolidays(url) {
      if (!url) {
        url = "api/user/me/holidays/";
      }

      await session.get(url).then((resp) => {
        this.userHolidays = resp.data.results;
        this.holidaysHasNextPage = resp.data.links.next;
        this.holidaysHasPreviousPage = resp.data.links.previous;
        this.perPage = resp.data.count;
        this.totalPages = resp.data.total_pages;
        this.currentPage = resp.data.current_page;
      });
    },
    pageClick(currentpage) {
      this.fetchUserHolidays(`api/user/me/holidays/?page=${currentpage}`);
    },

    changePassword() {
      if (!this.oldPassword || !this.newPassword || !this.newPasswordAgain) {
        this.alertMsg = "Παρακαλώ συμπληρώστε όλα τα πεδία";
        this.alertVariant = "danger";
        return;
      }

      session
        .put(`api/change-password/`, {
          old_password: this.oldPassword,
          new_password1: this.newPassword,
          new_password2: this.newPasswordAgain,
        })
        .then((resp) => {
          if (resp.data && resp.data.token) {
            this.alertMsg = "Ο κωδικός πρόσβασης άλλαξε με επιτυχία";
            this.alertVariant = "success";

            localStorage.setItem("key", resp.data.token);
            session.defaults.headers.Authorization = `Token ${resp.data.token}`;
          }
        })
        .catch((e) => {
          this.alertMsg = e.response.data;
          this.alertVariant = "danger";
        });
    },
  },
};
</script>
